type AnyObject = { [key: string]: any };

// 仅对普通对象(字面量 / Object.create(null))递归;Date、Dayjs、File、Blob、
// FormData 等类实例原样保留——此前对任何 object 都做 Object.entries,
// 会把 Dayjs/Date 拆成内部字段组成的普通对象,toJSON 丢失,请求体变成垃圾数据
export const isPlainObject = (value: unknown): value is AnyObject => {
  if (typeof value !== 'object' || value === null) return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};

// 递归去除对象中的空字符串 去除字符串前后的空格
export const removeInvalid = <T extends AnyObject>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj
      .map(removeInvalid)
      .filter((item) => item !== '' && item !== undefined) as unknown as T;
  } else if (isPlainObject(obj)) {
    const cleanedObj: AnyObject = {};
    for (const [key, value] of Object.entries(obj)) {
      const cleanedValue = removeInvalid(value);
      if (cleanedValue !== '' && cleanedValue !== undefined) {
        cleanedObj[key] = cleanedValue;
      }
    }
    return cleanedObj as T;
  } else if (typeof obj === 'string') {
    const trimmed = (obj as any)?.trim();
    return (trimmed === '' ? undefined : trimmed) as T;
  }
  return obj;
};

// 递归去除对象中的 null/undefined,并去除字符串前后的空格;空字符串原样保留。
// 请求体专用:后端契约「键缺省/null 不动旧值、'' 显式清空」,removeInvalid 会
// 把 '' 一并剥掉,导致表单清空字段保存后旧值复活(部门管理清空电话无效,
// 2026-09-10)。GET 查询参数仍用 removeInvalid(空串视为未筛选)。
export const removeNil = <T extends AnyObject>(obj: T): T => {
  if (Array.isArray(obj)) {
    return obj
      .map(removeNil)
      .filter((item) => item !== null && item !== undefined) as unknown as T;
  } else if (isPlainObject(obj)) {
    const cleanedObj: AnyObject = {};
    for (const [key, value] of Object.entries(obj)) {
      const cleanedValue = removeNil(value);
      if (cleanedValue !== null && cleanedValue !== undefined) {
        cleanedObj[key] = cleanedValue;
      }
    }
    return cleanedObj as T;
  } else if (typeof obj === 'string') {
    return (obj as any).trim() as T;
  }
  return obj;
};
